import { Outlet } from "react-router-dom";

const RouteGuard = () => {
  // Page-level access gating is disabled while the menu is driven by the
  // static frontend config (backend RBAC not wired up yet) — every route
  // in the static menu is reachable regardless of pageAccessDetails.
  return <Outlet />;
};

export default RouteGuard;
